/* Common Imports */

import React from "react";

/* Redux Imports */

import { connect } from "react-redux";
import StateInterface from "../../redux-magic/state-interface";
import { updateReduxSessionThunk, wrapper } from "../../redux-magic/store";
import {
	bottom_subscribe_buy_beegru_points,
	chat_states,
	notifications_page,
} from "../../redux-magic/sub-state-data/sub-state-data";

/* Component Imports */

import { Theme } from "@mui/material/styles";
import Layout from "../../components/layout-components/Layout";

/* Loadable Components */

/* Security library*/
import { useRouter } from "next/router";
import RentalYieldCalculator from "../../components/page-sections/Calculators/RentalYieldCalculator";
import { validateClientSession } from "../../lib/auth/helpers";
import authenticationTokenGenerator from "../../lib/authentication_token_generator";

export const getServerSideProps = wrapper.getServerSideProps((store: any) => async (context: any) => {
	const server_session = await authenticationTokenGenerator(context);
	return {
		props: {
			server_session: server_session,
		},
	};
});

const RentalYieldPage = ({
	dispatch,
	server_session,
	session,
	redux_session,
	theme,
	showInactivityDialog,
	profile_context,
	new_business_profile_url,
	new_listing_url,
	notification_data,
	newNotification,
	newPropertyData,
	newServiceData,
	search_filter_state,
	searchanimationsettings,
	bottom_buy_subscription,
	open_post_modal,
	broadcastData,
	chatStates,
	newChatMessage,
	realtimeWebsocket,
	login_flow_global_state,
	feature_discovery_tracker,
}: {
	dispatch: Function;
	server_session: any;
	session: any;
	redux_session: StateInterface["redux_session"];
	theme: Theme;
	showInactivityDialog: boolean;
	profile_context: StateInterface["profile_context"];
	new_business_profile_url: StateInterface["new_business_profile_url"];
	new_listing_url: StateInterface["new_listing_url"];
	notification_data: StateInterface["notifications_page"];
	newNotification?: StateInterface["notification"] | null;
	newPropertyData: StateInterface["new_property_data"];
	newServiceData: StateInterface["new_service_data"];
	search_filter_state: StateInterface["search_filters_state"];
	searchanimationsettings: StateInterface["search_animation_settings"];
	bottom_buy_subscription: StateInterface["bottom_subscribe_buy_beegru_points"];
	open_post_modal: StateInterface["open_post_modal"];
	broadcastData: StateInterface["broadcast_data"];
	chatStates: StateInterface["chat_states"];
	newChatMessage?: StateInterface["chat_message"] | null;
	realtimeWebsocket: any;
	login_flow_global_state: StateInterface["login_flow_global_state"];
	feature_discovery_tracker: StateInterface["feature_discovery_tracker"];
}) => {
	const [reduxSessionUpdated, setReduxSessionUpdated] = React.useState<boolean>(false);

	const router = React.useRef(useRouter()).current;

	React.useEffect(() => {
		if (server_session && validateClientSession(server_session)) {
			dispatch(updateReduxSessionThunk(server_session));
		}
		setReduxSessionUpdated(true);
	}, [server_session, dispatch]);

	return (
		<React.Fragment>
			<Layout
				title="Rental Yield Calculator | Beegru"
				description="Measure your property’s rental performance with Beegru’s Rental Yield Calculator. Quick, accurate, and perfect for investors."
				keywords="rental yield calculator, property investment calculator, rental income calculator, ROI calculator, real estate investment, property returns, payback period calculator"
				session={redux_session}
				redux_session_updated={reduxSessionUpdated}
				showInactivityDialog={showInactivityDialog}
				theme={theme}
				dispatch={dispatch}
				profile_context={profile_context}
				new_business_profile_url={new_business_profile_url ? new_business_profile_url : ""}
				new_listing_url={new_listing_url ? new_listing_url : ""}
				notifications={notification_data ? notification_data : notifications_page}
				new_notification={newNotification ? newNotification : null}
				newPropertyData={newPropertyData}
				newServiceData={newServiceData}
				search_filter_state={search_filter_state}
				searchanimationsettings={searchanimationsettings}
				bottom_buy_subscription={bottom_buy_subscription ? bottom_buy_subscription : bottom_subscribe_buy_beegru_points}
				open_post_modal={open_post_modal}
				broadcastData={broadcastData}
				showChatFab
				chatStates={chatStates ? chatStates : chat_states}
				new_chat_message={newChatMessage ? newChatMessage : null}
				realtime_websocket={realtimeWebsocket}
				login_flow_global_state={login_flow_global_state}
				broadcastFeatureDiscoveryTracker={
					feature_discovery_tracker
						? feature_discovery_tracker.broadcast
						: {
								viewed: false,
								viewed_at: "",
								skipped: false,
							}
				}
				noContain={[0]}
			>
				<div
					style={{
						paddingTop: "4rem",
					}}
				>
					<RentalYieldCalculator />
				</div>
			</Layout>
		</React.Fragment>
	);
};

export default connect(
	({
		globalState: {
			profile_context,
			new_listing_url,
			new_business_profile_url,
			notifications_page,
			redux_session,
			new_property_data,
			new_service_data,
			search_filters_state,
			search_animation_settings,
			bottom_subscribe_buy_beegru_points,
			open_post_modal,
			broadcast_data,
			chat_states,
			login_flow_global_state,
			feature_discovery_tracker,
		},
	}: {
		globalState: {
			profile_context: StateInterface["profile_context"];
			new_listing_url: StateInterface["new_listing_url"];
			new_business_profile_url: StateInterface["new_business_profile_url"];
			notifications_page: StateInterface["notifications_page"];
			redux_session: StateInterface["redux_session"];
			new_property_data: StateInterface["new_property_data"];
			new_service_data: StateInterface["new_service_data"];
			search_filters_state: StateInterface["search_filters_state"];
			search_animation_settings: StateInterface["search_animation_settings"];
			bottom_subscribe_buy_beegru_points: StateInterface["bottom_subscribe_buy_beegru_points"];
			open_post_modal: StateInterface["open_post_modal"];
			broadcast_data: StateInterface["broadcast_data"];
			chat_states: StateInterface["chat_states"];
			login_flow_global_state: StateInterface["login_flow_global_state"];
			feature_discovery_tracker: StateInterface["feature_discovery_tracker"];
		};
	}) => ({
		profile_context: profile_context,
		new_listing_url: new_listing_url,
		new_business_profile_url: new_business_profile_url,
		notification_data: notifications_page,
		redux_session: redux_session,
		newPropertyData: new_property_data,
		newServiceData: new_service_data,
		search_filter_state: search_filters_state,
		searchanimationsettings: search_animation_settings,
		bottom_buy_subscription: bottom_subscribe_buy_beegru_points,
		open_post_modal: open_post_modal,
		broadcastData: broadcast_data,
		chatStates: chat_states,
		login_flow_global_state: login_flow_global_state,
		feature_discovery_tracker,
	}),
)(RentalYieldPage);
